import './ExportCard.css';
import { connect } from 'react-redux';
import { download } from '../../stores/actions/exportActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import CancelIcon from '@material-ui/icons/Cancel';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon.js';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import Download from '@material-ui/icons/CloudDownload';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import InputLabel from '@material-ui/core/InputLabel';
import React, { ChangeEvent } from 'react';
import dashboardStyle from '../../assets/jss/views/dashboardStyleTS';
import styles from '../../assets/jss/views/dashboardStyle';
import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import { closeSweetAlertStyle } from '../../helpers/CustomStyles';
import { ClassNameMap } from '@material-ui/styles';

const style = {
	cardTitle,
	cardCategory: styles.cardCategory,
};

interface IExportForm {
	Start: string;
	End: string;
	Format: string;
	NodeID: number;
}

interface IExportCardProps {
	nodeID: number;
	name: string;
	systemName: string;
	exportStart: string;
	exportStop: string;
	classes: ClassNameMap;
	download: (exportForm: IExportForm, name: string, systemName: string, node: number) => void;
	hideAlert: () => void;
}
interface IExportCardState {
	startError: boolean;
	stopError: boolean;
	nodeID: number;
	name: string;
	systemName: string;
	date: Date[];
	exportStart: string;
	exportStop: string;
}

class ExportCard extends React.Component<IExportCardProps, IExportCardState> {
	state = {
		startError: false,
		stopError: false,
		nodeID: this.props.nodeID,
		name: this.props.name,
		systemName: this.props.systemName,
		exportStart: '',
		exportStop: '',
		date: [new Date(this.props.exportStart), new Date(this.props.exportStop)],
	};

	onChangeStart = (event: ChangeEvent): void => {
		const targetValue = (event.target as HTMLInputElement).value;
		this.setState({
			exportStart: targetValue,
			startError: targetValue === '',
		});
	};

	onChangeStop = (event: ChangeEvent): void => {
		const targetValue = (event.target as HTMLInputElement).value;
		this.setState({
			exportStop: targetValue,
			stopError: targetValue === '',
		});
	};

	handleDownload = (): void => {
		let Start = new Date(this.state.date[0]).toISOString();
		let End = new Date(this.state.date[1]).toISOString();
		let NodeID = this.state.nodeID;
		let Format = 'csv';

		let exportForm = { Start, End, Format, NodeID };
		this.props.download(exportForm, this.state.name, this.state.systemName, this.state.nodeID);
		this.props.hideAlert();
	};

	onChange = (date: Date[]) => this.setState({ date: date });

	handleDateRangePickerRender = (): JSX.Element => {
		const { date } = this.state;
		return (
			<DateRangePicker
				locale='en-US'
				onChange={this.onChange}
				value={date}
				format='y-MM-dd'
				clearIcon={null}
				autoFocus={false}
				style={{ width: '100%' }}
			/>
		);
	};

	render() {
		const { name, startError, stopError } = this.state;

		return (
			<ErrorComponent Children message='Something was wrong'>
				<GridContainer>
					<GridItem xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button
							simple
							justIcon
							color='info'
							style={closeSweetAlertStyle}
							onClick={this.props.hideAlert}
							data-testid='cancelButton'
						>
							<CancelIcon style={{ width: '20px', height: '20px' }} />
						</Button>
					</GridItem>
				</GridContainer>
				<Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} data-testid='exportCard'>
					<CardHeader color='info' icon>
						<CardIcon color='info'>
							<Download />
						</CardIcon>
						<p style={{ ...style.cardCategory, textAlign: 'left' }}>Export data:</p>
						<h3 style={{ ...style.cardTitle, textAlign: 'left' }}>{name}</h3>
					</CardHeader>
					<CardBody>
						<form>
							<GridContainer style={{ margin: '0 0 0 -15px' }}>
								<GridItem xs={12}>
									<InputLabel style={{ fontSize: '1.15rem' }}>Pick data range:</InputLabel>
									<br />
									{this.handleDateRangePickerRender()}
								</GridItem>
								<GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
									<Button
										disabled={startError || stopError}
										color='info'
										onClick={() => this.handleDownload()}
										data-testid='downloadButton'
										className='downloadButton'
									>
										Download
									</Button>
								</GridItem>
							</GridContainer>
						</form>
					</CardBody>
				</Card>
			</ErrorComponent>
		);
	}
}

const actions = { download };

export const ExportCardWithStyles = dashboardStyle(ExportCard);
export default connect(null, actions)(ExportCardWithStyles);
